import {Component, OnInit} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  constructor(private translate: TranslateService) {
    translate.setDefaultLang('de');
    const savedLang = localStorage.getItem('language') || 'de';
    translate.use(savedLang);
  }

  ngOnInit(): void {
    $(document).ready(() => {
    });
  }
}
